<div>
  <ng-container class="mx-auto pt-[22px] px-[1.25rem] h-[calc(100%-100px)]">
    <nx-pageTitle-box class="mb-3" [label]="'Aufgaben'" [icon]="'icon-check'" [iconToolTip]="'Aufgaben'"
    [bcRootLvlLabel]="'Einstellungen'"
    [bcRootLvlPath]="'settings'">
    </nx-pageTitle-box>
  </ng-container>

    <div class="body">
      <p-tabView [scrollable]="true">
        <p-tabPanel [header]="'Aufgabentypen'">
          <div class="mt-[1.25rem]">
            <app-task-types/>
          </div>
        </p-tabPanel>
    </p-tabView>
    </div>
</div>
